module.exports = __webpack_public_path__ + "img/area cctv dan ott box.02dc5b5a.jpg";